export default __webpack_public_path__ + "static/media/partner_logo_06.d404902e.png";